import { PagoMiembroFields, pagoMiembroValido, pagoMiembroPayload } from "../../eventos/PagoMiembroFields";
import React, { useEffect, useState } from "react";
import { TextField, Button, Grid, Box, Autocomplete, Typography } from "@mui/material";
import { getTrabajadores, getUsuariosCliente, postEvento } from "../../../services/apis";
import AutocompleteList from "../../../utils/componentes-utiles/AutocompleteList";
import { AlertError, AlertSuccess } from "../../../utils/componentes-utiles/AlertError";

export const FormCrearActivad = ({ fecha, cargarEventos, cerrarFormulario, tEventoSelec }) => {
	const [pagoMiembro, setPagoMiembro] = useState({ miembro_paga: 0, precio_miembro: "" });
	const [asunto, setAsunto] = useState("");
	const [descripcion, setDescripcion] = useState("");
	const [invitados, setInvitados] = useState("");
	const [horaInicio, setHoraInicio] = useState();
	const [horaFin, setHoraFin] = useState();
	const [trabajadoresSelec, setTrabajadoresSelec] = useState([]);
	const [errorAlert, setErrorAlert] = useState(false);
	const [fechaSeleccionada, setFechaSeleccionada] = useState(fecha || null);
	const [successAlert, setSuccessAlert] = useState(false);

	const [opTrabajadores, setOpTrabajadores] = useState([]);
	const cargarTrabajadores = async () => {
		try {
			const response = await getTrabajadores();
			const tmp = [...response.data];
			const newTmp = tmp.map((item, index) => ({
				label: item.nombre,
				value: item.id
			}))
			setOpTrabajadores(newTmp);
		} catch (error) {
			console.error("Error en carregar usuaris", error)
		}
	}

	const isNullInObject = (obj) => {
		// Camps que s'ometen en la validació
		const camposExcepcion = ['', 'precio_persona', 'miembro_paga', 'precio_miembro', 'precios_tickets'];

		return Object.keys(obj).every(key => {
			if (camposExcepcion.includes(key)) {
				return true;
			}
			return obj[key] !== null && obj[key] !== '' && obj[key] != 0;
		});
	};
	const handleSubmit = () => {
		let fechaFomat = "";
		const [dia, mes, anio] = fecha.split('-');
		fechaFomat = `${anio}-${mes}-${dia}`;
		console.log(fechaFomat);

		const data = {
            ...pagoMiembroPayload(pagoMiembro),
			asunto: asunto,
			descripcion: descripcion,
			horaInicio: horaInicio,
			fecha: fechaFomat,
			gastaTicket: true,
			usuarioEncargado: trabajadoresSelec[0]?.value || null,
			id_usuarios_encargados: trabajadoresSelec.map((trabajador) => trabajador.value),
			id_tipoEvento: 3,
			precio_persona: 0,
			precios_tickets: [],
		};


		const tareaComprobada = isNullInObject(data);

		if (!tareaComprobada || !pagoMiembroValido(pagoMiembro)) {
			console.error("Hi ha camps buits o no vàlids en l'esdeveniment");
			setErrorAlert(true);
			return; // Detener la ejecución si hay campos no válidos
		}
		console.log(data);

		crearEvento(data);
		console.log("Dades de l'activitat:", data);

	};

	const crearEvento = async (data) => {

		try {
			const resposne = await postEvento(data);
			console.log("Esdeveniment creat:", resposne);
			if (resposne.success) {
				setSuccessAlert(true);
				cargarEventos();
				cerrarFormulario();
			}

		}
		catch (error) {
			console.error("Error en crear l'esdeveniment:", error);
		}
	};
	useEffect(() => {
		cargarTrabajadores();
	}, []);


	return (
		<Box className="events-create-section events-type-activity" sx={{ display: tEventoSelec == 3 ? 'flex' : 'none' }}>
			<Typography className="events-create-section-title">Activitat</Typography>
			<Grid container spacing={2}>
                <PagoMiembroFields form={pagoMiembro} onChange={(field, value) => setPagoMiembro((prev) => ({ ...prev, [field]: value }))} />
				<Grid
                size={{ xs: 12 }}>
					<TextField
						fullWidth
						label="Nom"
						value={asunto}
						onChange={(e) => setAsunto(e.target.value)}
						required
					/>
				</Grid>
				{/* <Grid>
					Assistents: en crear l'esdeveniment es podran apuntar m?s assistents i convidats
					<AutocompleteList array={opTrabajadores} setArray={setTrabajadorSelec} />

				</Grid> */}
				<Grid
                size={{ xs: 12 }}>
					<TextField
						fullWidth
						label="Activitat"
						value={descripcion}
						onChange={(e) => setDescripcion(e.target.value)}
						required
					/>
				</Grid>
				<Grid
                size={{ xs: 12 }}>
					<TextField
						fullWidth
						label="Hora d'inici"
						type="time"
						value={horaInicio || ""}
						onChange={(e) => setHoraInicio(e.target.value)}
						InputLabelProps={{
							shrink: true, // perquè l'etiqueta no se solape
						}}
					/>
				</Grid>

				{/* <Grid
                size={{ xs: 6 }}>
					<TextField
						fullWidth
						label="Hora final"
						type="time"
						value={horaFin || ""}
						onChange={(e) => setHoraFin(e.target.value)}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</Grid> */}
				<Grid
                size={{ xs: 12 }}>
					<Autocomplete
						multiple
						disableCloseOnSelect
						fullWidth
						className={opTrabajadores ? "inputDateInput" : 'inputDateInput-empty'}
						disablePortal
						id="combo-box-demo"
						options={opTrabajadores}
						value={trabajadoresSelec}
						onChange={(event, newValue) => setTrabajadoresSelec(newValue)}
						renderInput={(params) => <TextField {...params} label="Usuaris encarregats*" />}
					/>
				</Grid>
				<Grid
                size={{ xs: 12 }}>
					<Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
						Crear activitat
					</Button>
				</Grid>
			</Grid>
			{errorAlert && (
				<AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Falta omplir algun camp obligatori"} />
			)}
			{successAlert && (
				<AlertSuccess open={successAlert} setOpen={setSuccessAlert} titulo={"Èxit"} mensaje={"Activitat creada correctament"} tipo={"success"} />
			)}
		</Box>
	);
};
